import { MutationHookOptions, gql } from '@apollo/client';

import { useEdeMutation, useEdeQueryName } from 'routes/marketplace-ede/context/edeQueryProvider';

const queryType = 'OPT_OUT_POLICY';

const useOptOutPolicyMutation = (options: MutationHookOptions = {}) => {
  const queryName = useEdeQueryName(queryType);

  const OPT_OUT_POLICY_MUTATION = gql`
    mutation OptOut($appID: ID!, $payload: OptOutPolicyInput) {
      ${queryName} (appID: $appID, payload: $payload) {
        success
        action
        data
      }
    }
  `;

  return useEdeMutation(OPT_OUT_POLICY_MUTATION, options);
};

export default useOptOutPolicyMutation;
